import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { Nav, Button, Container, Modal } from 'react-bootstrap'; // Type defintitions

import * as TYPES from '../../types'; // JSS

import { Link } from '@sitecore-jss/sitecore-jss-react'; // Design System

import Logo from "../Logo";

var AccountMenu = /*#__PURE__*/function (_Component) {
  _inherits(AccountMenu, _Component);

  var _super = _createSuper(AccountMenu);

  function AccountMenu(props) {
    var _this;

    _classCallCheck(this, AccountMenu);

    _this = _super.call(this, props);
    _this.state = {
      accountNavVisible: props.accountNavVisible
    };
    return _this;
  }

  _createClass(AccountMenu, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var accountNavVisible = this.props.accountNavVisible;

      if (prevProps.accountNavVisible !== accountNavVisible) {
        this.setState({
          accountNavVisible: accountNavVisible
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onHide = _this$props.onHide,
          model = _this$props.model,
          handleLogout = _this$props.handleLogout;
      var accountNavVisible = this.state.accountNavVisible;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
        className: "position-absolute"
      }, /*#__PURE__*/React.createElement(Modal, {
        className: "cb-menu-secondary",
        show: accountNavVisible,
        onHide: onHide,
        autoFocus: true,
        keyboard: true
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "cb-menu-secondary__logo--lg"
      }, /*#__PURE__*/React.createElement(Logo, {
        model: model
      }))), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Nav, {
        className: "cb-menu-secondary__nav",
        as: "ul"
      }, /*#__PURE__*/React.createElement(Nav.Link, {
        as: "li"
      }, /*#__PURE__*/React.createElement("a", {
        href: "/account-management"
      }, "My Account")), /*#__PURE__*/React.createElement(Nav.Link, {
        as: "li"
      }, /*#__PURE__*/React.createElement("a", {
        href: "/account-management/my-orders"
      }, "Order History")), /*#__PURE__*/React.createElement(Nav.Link, {
        as: "li"
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: function onClick(e) {
          e.preventDefault();
          return handleLogout();
        }
      }, "Logout")))))));
    }
  }]);

  return AccountMenu;
}(Component);

export { AccountMenu as default };